module.exports = __webpack_public_path__ + "img/printrite .10c128c2.svg";